import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // console.log('Rota atual:', currentState.url);
    // console.log('Rota de destino:', nextState?.url);
    if (nextState?.url?.includes('lgpd')
      || nextState?.url?.includes('conteudo')
      || nextState?.url?.includes('documento')
      || nextState?.url?.includes('home')
      || nextState?.url?.includes('relatorios')
      || nextState?.url?.includes('simulacao-emprestimo')
    ) {
      const podesair = component.canDeactivate ? component.canDeactivate() : true;
      // console.log('podesairpodesairpodesairpodesair', podesair);
      return podesair;
    }
    return true;
  }
}
